// extracted by mini-css-extract-plugin
export default {"content":"EmailConfirm_content__am871"};